<template>
    <div class="m-skin-pack">
        <div class="title"></div>

        <!-- zb pack -->
        <div class="zb-pack">
            <div class="content">
                <div class="task-rate">当前已领取：{{ $store.state.task[tid].giftRate  }}/{{ $store.state.task[tid].conditionValue }}份</div>
                <div class="game-icon">
                    <div class="reward-pic" v-tips="'1'">
                        <game-item :id="'1'" :num="100" :locked="true"></game-item>
                    </div>                      
                </div>

                <div class="u-btn apply" :class="{'disabled' : $store.state.task[tid].finishRate == $store.state.task[tid].giftRate && $store.state.userinfo.areaId }" @click="apply_599ex()"></div>
            </div>
        </div>
        <!-- end -->

        <!-- skin pack -->
        <div class="skin-pack">
            <div class="pannel">
                <div class="goods-list flex-wrap">
                    <div class="goods-item" v-for="(goods,index) in goods_list.slice(now_page * goods_perpage , goods_perpage * (now_page + 1))" :key="index">                       
                        <div class="goods-wrapper">
                            <div class="goods-pic" v-tips="goods.giftId">
                                <game-item :id="goods.giftId" :num="goods.sendNum" :locked="true"></game-item>
                            </div>
                        </div>

                        <div class="item-name">{{ goods.giftName }}</div>
                    </div>
                </div>

                <div class="u-btn apply-2399" @click="buy_2399pass()"></div>

                <div class="pages-ui">
                    <div class="u-btn page prev" @click="prev" :class="{'disabled' : now_page == 0}"></div>
                    <div class="page-item" v-for="n in total_page" :key="n" :class="{'act' : now_page == n - 1}" @click="page(n - 1)">{{ n }}</div>
                    <div class="u-btn page next" @click="next" :class="{'disabled' : now_page == total_page - 1}"></div>
                </div>
                
            </div>
            
        </div>
        <!-- end -->

        <!-- pack collection -->
        <div class="pack-collection">
            <div class="slogen"></div>
            <div class="skin-view">
                <div class="skin-item main-skin">
                    <div class="skin-pic" :class="skin_config.now.id" v-tips="skin_config['now'].id"></div>
                    <!-- <div class="skin-status" v-if="skin_status[skin_config['now'].sid.toLowerCase() + '_flag'] == 1"></div> -->
                </div>

                <div class="collection-list flex-wrap flex-start-center">
                    <div class="skin-item in-list" v-for="(skin,index) in skin_config.list.slice(now_skin_page * skin_perpage , skin_perpage * (now_skin_page + 1))" :key="index">
                        <div class="skin-pic" :class="[ skin.id , 'l-' + (index + 1 + now_skin_page * skin_perpage)]" v-tips="skin.id"></div>
                        <div class="skin-status" v-if="skin_status[skin.sid.toLowerCase() + '_flag'] == 1"></div>
                    </div>
                </div>

                <div class="pages-ui">
                    <div class="u-btn page prev" @click="prev_skin" :class="{'disabled' : now_skin_page == 0}"></div>
                    <div class="page-item" v-for="n in total_skin_page" :key="n" :class="{'act' : now_skin_page == n - 1}" @click="page_skin(n - 1)">{{ n }}</div>
                    <div class="u-btn page next" @click="next_skin" :class="{'disabled' : now_skin_page == total_skin_page - 1}"></div>
                </div>

            </div>
        </div>
        <!-- end -->
    </div>
</template>

<script>
import {
    apiQuerySkin,
    api599Apply,
} from '@/api/index';

export default {
    data (){
        return {
            skin_config : {
                list : [
                    {id : 'FL70',sid : 'AC38',hero : '太史慈',name : '请叫我鸡王'},
                    {id : 'FN22',sid : 'AC74',hero : '邓艾',name : '天命之子'},
                    {id : 'FN38',sid : 'BC01',hero : '布小蛮',name : '布鸡道'},
                    {id : 'FP40',sid : 'MC90',hero : '梦*蔡文姬',name : '闻鸡破晓'},
                    {id : 'FP94',sid : 'AC10',hero : '孙策',name : '天命狐王'},
                    {id : 'FQ66',sid : 'MC22',hero : '梦*刘备',name : '天命大帝'},
                    {id : 'FS24',sid : 'AC64',hero : '辛宪英',name : '疯狂吉娃'},
                    {id : 'FT00',sid : 'MC44',hero : '梦*庞德',name : ''},
                    {id : 'FT84',sid : 'AC24',name : '程昱',name : ''},
                    {id : 'FU64',sid : 'MC27',name : '梦*马超',name : ''},
                    {id : 'FV38',sid : 'MC27',name : '梦*XX'}
                ],
                now : {id : 'FW14',name : ''},//FW14
            },
            skin_status : {},
            tid : 't03',
            goods_list : [
                {"giftId":"KB55","giftName":"无敌鸡王冲锋包(7天)","sendNum":"1"},
                {"giftId":"KB56","giftName":"天命之子必胜包(7天)","sendNum":"1"},
                {"giftId":"KW23","giftName":"天命公主出巡包（7天）","sendNum":"1"},
                {"giftId":"LP51","giftName":"天命圣女守卫包（7天）","sendNum":"1"},
                {"giftId":"ME02","giftName":"枪王之王出征包（7天）","sendNum":"1"},
                {"giftId":"KD85","giftName":"天命大帝赐福包（7天）","sendNum":"1"},
                {"giftId":"NC34","giftName":"疯狂吉娃献瑞包（7天）","sendNum":"1"},
                {"giftId":"NZ02","giftName":"暗藏沙鸡锦猴包（7天）","sendNum":"1"},
                {"giftId":"OL63","giftName":"鸡肉猛男壮怀包（7天）","sendNum":"1"},
            ],
            goods_perpage : 6,
            now_page : 0,
            total_page : 1,
            skin_perpage : 6,
            now_skin_page : 0,
            total_skin_page : 0,
        }
    },
    mounted(){
        if(this.$store.state.userinfo.areaId)this.skin_query();
        this.total_page = Math.ceil(this.goods_list.length/this.goods_perpage);
        this.total_skin_page = Math.ceil(this.skin_config.list.length/this.skin_perpage);

        this.skin_config.list = this.skin_config.list.reverse();
    },
    computed :{
        _zid (){
            return this.$store.state.userinfo.areaId;
        },    
    },
    watch : {
        _zid : {
            handler(newVal, oldVal) {
                if(newVal != oldVal){
                    this.skin_query();
                }              
            },
            deep: true
        },                         
    },      
    methods : {
        skin_query (){
            apiQuerySkin().then(
                res => {
                    this.skin_status = res.data;
                }
            )
        },
        prev (){
            return this.now_page = Math.max(0,--this.now_page)
        },
        prev_skin (){
            return this.now_skin_page = Math.max(0,--this.now_skin_page)
        },
        next (){
            return this.now_page = Math.min((this.total_page-1),++this.now_page)
        },
        next_skin (){
            return this.now_skin_page = Math.min((this.total_skin_page-1),++this.now_skin_page)
        },
        page (index){
            return this.now_page = index;
        },
        page_skin (index){
            return this.now_skin_page = index;
        },      
        apply_599ex(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            if(!this.$store.state.task[this.tid].taskOrderId)return this.$msg_modal('未达成领取条件')

            api599Apply({orderId : this.$store.state.task[this.tid].taskOrderId}).then(
                res => {
                    this.$msg_modal('领取成功~');
                    this.$update_evt ();
                },
                rej => {
                    this.$msg_modal(rej.message);
                }
            )
        },
        buy_2399pass(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            this.$pass_comfirm({
                text : '购买特惠包吗？',
                gid : 32,
                num : 1,
                cost : 2399,                
            });
        },        
    },
}
</script>

<style lang="scss" scoped>
.title{
    width: 750px;
    height: 161px;
    margin: 0 auto;
    background-image: url(~@/assets/images/title-2.png);
}

.zb-pack{
    width: 712px;
    height: 397px;
    margin: 0 auto 76px;
    background-image: url(~@/assets/images/bg-zb.png);

    .content{
        padding: 125px 50px 0 307px;
    }

    .task-rate{
        color: #dfd6c1;
        text-align: center;
    }

    .game-icon{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 91px;
        height: 91px;
        margin-left: 125px;
        margin-top: 10px;
        margin-bottom: 20px;
        background-image: url(~@/assets/images/bg-item_zb.png);

        .reward-pic{
            width: 69px;
            height: 69px;
        }     
    }
    
    .u-btn.apply{
        width: 270px;
        height: 82px;
        margin-left: 40px;
        background-image: url(~@/assets/images/btn-apply_main.png);        
    }
}

.skin-pack{
    .pannel{
        position: relative;
        width: 706px;
        height: 886px;
        padding-top: 130px;
        margin: 0 auto;
        box-sizing: border-box;
        background-image: url(~@/assets/images/pannel-pack.png);
        
        // &::before{
        //     display: block;
        //     content: '';
        //     position: absolute;
        //     top: -10px;
        //     left: 140px;
        //     width: 108px;
        //     height: 84px;
        //     background-image: url(~@/assets/images/layer-c2.png);
        //     z-index: 1;
        //     animation: npc 2s ease-in-out infinite;
        // }
        
        &::after{
            display: block;
            content: '';
            position: absolute;
            bottom: -10px;
            right: 10px;
            width: 119px;
            height: 125px;
            background-image: url(~@/assets/images/layer-pack.png);
            z-index: 1;
            animation: shake 6s ease-in-out infinite;
        }
        
        .goods-list{
            margin: 28px 52px 0;

            .goods-item{
                position: relative;
                width: 174px;
                height: 229px;
                margin: 0 10px 10px;
                padding-top: 16px;
                box-sizing: border-box;                
                color: #eedfbc;
                font-size: 22px;
                text-align: center;
                background-image: url(~@/assets/images/bg-item_skin.png);
            }

            .item-name{
                font-family: 'Alimama';
                margin: 10px 20px 0;
            }

            .goods-wrapper{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 131px;
                height: 115px;
                margin: 0 auto;
                background-image: url(~@/assets/images/bg-item_skin_in.png);
                background-color: transparent;
                border: none;
            }

            .goods-pic{
                margin-top: 3px;
            }
        }        

    }

    .apply-2399{
        position: absolute;
        left: 50%;
        bottom: 140px;
        margin-left: -165px;
        width: 330px;
        height: 82px;
        // margin: 20px auto 0;
        background-image: url(~@/assets/images/btn-buy-2399.png);       
    }
}

.pack-collection{
    position: relative;
    width: 706px;
    height: 1036px;
    margin: 20px auto 0;
    padding-top: 45px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/pannel-colection.png);

    .slogen{
        width: 520px;
        height: 36px;
        margin: 0 auto 10px;
        background-image: url(~@/assets/images/slogen-skin.png);
    }

    .collection-list{
        width: 640px;
        margin: 25px auto 0;
    }

    .skin-item{

        position: relative;

        .skin-status{
            position: absolute;
            right: 20px;
            top: 0;
            width: 33px;
            height: 30px;
            background-image: url(~@/assets/images/skin/icon-get.png);
        }

        &.main-skin{

            .skin-pic{
                width: 640px;
                height: 254px;
                margin: 0 auto;
                background-image: url(~@/assets/images/skin/main.png);
            }

            .skin-status{
                right: 85px;
            }
        }

        &.in-list{

            .skin-pic{
                width: 208px;
                height: 274px;
                margin: 0 2px 25px;
                
                @for $i from 1 through 11{
                    &.l-#{$i}{
                        background-image: url(~@/assets/images/skin/#{$i}.png);
                    }                   
                }
            }

        }
    }

    .pages-ui{
        bottom: 45px;
    }
}

.page.u-btn{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width:  25px;
    height: 43px;
    background-repeat: no-repeat;
}
.page.u-btn.prev{
    left: -100px;
    background-image: url(~@/assets/images/btn-prev_2.png);
}
.page.u-btn.next{
    right: -100px;
    background-image: url(~@/assets/images/btn-next_2.png);
}

.pages-ui{
    position: absolute;
    left: 50%;
    bottom: 80px;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 200px;
    color: transparent;
}

.page-item{
    width: 20px;
    height: 20px;
    line-height: 20px;
    margin: 0 10px;
    text-align: center;
    background-image: url(~@/assets/images/nav-item_2.png);

}

.page-item.act{
    background-image: url(~@/assets/images/nav-act_2.png);
}
</style>